import React from 'react';
import { useSelector } from 'react-redux';

const LatestPosts = ({ title, posts }) => {
  return (
    <div class='sidebar-widget widget_alitheme_lastpost mb-50'>
      <div class='widget-header position-relative mb-20 pb-10'>
        <h5 class='widget-title mb-10'>{title ? title : 'Bài mới nhất'}</h5>
        <div class='bt-1 border-color-1'></div>
      </div>
      <div class='post-block-list post-module-1'>
        <ul class='list-post'>
          {posts.map((item) => (
            <li class='mb-30' key={item.id}>
              <div class='d-flex'>
                <div class='post-thumb d-flex mr-15 border-radius-5 img-hover-scale'>
                  <a
                    href={`/${
                      item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'
                    }/${item.slug}`}
                  >
                    <img src={item.thumbnail} alt='' />
                  </a>
                </div>
                <div class='post-content media-body'>
                  <div class='entry-meta meta-0 mb-10'>
                    <a>
                      <span
                        class='post-in background5 color-white font-small'
                        style={{
                          backgroundColor: item.background_color_category,
                        }}
                      >
                        {item.name_category}
                      </span>
                    </a>
                  </div>
                  <h6 class='post-title mb-10 text-limit-2-row'>
                    {item.short_description}
                  </h6>
                  <div class='entry-meta meta-1 font-x-small color-grey'>
                    <span class='post-on'>{item.created_at}</span>
                    {/* <span class='hit-count has-dot'></span> */}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default LatestPosts;
